<template>
  <div id="dashboardIndex">
    <div class="headerLeft">
      <div :class="checkKey === 'gkzx' ? isEyeshield ? 'headerBtnIsAcitve_eyes' : 'headerBtnIsAcitve' : isEyeshield ? 'headerBtn_eyes' :'headerBtn'" style="margin-right: 12px"
        @click="changeCheck('gkzx')">管控中心</div>
      <div :class="checkKey === 'tsjk' ? isEyeshield ? 'headerBtnIsAcitve_eyes' : 'headerBtnIsAcitve' : isEyeshield ? 'headerBtn_eyes' :'headerBtn'" style="margin-right: 12px"
        @click="changeCheck('tsjk')">态势监控</div>
      <div :class="checkKey === 'kyxt' ? isEyeshield ? 'headerBtnIsAcitve_eyes' : 'headerBtnIsAcitve' : isEyeshield ? 'headerBtn_eyes' :'headerBtn'" style="margin-right: 12px"
        @click="changeCheck('kyxt')">空域协同</div>
      <div :class="checkKey === 'sjgk' ? isEyeshield ? 'headerBtnIsAcitve_eyes' : 'headerBtnIsAcitve' : isEyeshield ? 'headerBtn_eyes' :'headerBtn'" @click="changeCheck('sjgk')">市级管控</div>
    </div>
    <div v-show="uBtnPermissionList.includes('eyeshieldBtn')" class="eyesBtn" :class="isEyeshield ? 'eyeshieldModel' : 'ordinaryModel'" @click="changeIndexTheme"></div>
    <div   :class="isEyeshield ? 'eyeshieldModelHeader' : 'ordinaryModelHeader'">
      <div class="headerMiddle">
        上海市静安区市北高新低空智能管控服务平台
      </div>
      <div class="headerRight">
        {{ timeInfo.currentTime }}&nbsp; {{ timeInfo.date }} &nbsp;{{ timeInfo.weekday }}
      </div>
    </div>
    <div class="contentWrap">
      <TaskControl :wsBigScreen="ws" :isEyeshield="isEyeshield" :isBigScreen="true" v-if="checkKey === 'tsjk'">
      </TaskControl>
      <ThreedSpaceControll :isEyeshield="isEyeshield" v-else-if="checkKey === 'kyxt'"></ThreedSpaceControll>
      <Index :wsBigScreen="ws" :isEyeshield="isEyeshield" v-else-if="checkKey === 'gkzx'"></Index>
      <MunicipalLevelData :wsBigScreen="ws" :isEyeshield="isEyeshield" :isBigScreen="true"
        v-else-if="checkKey === 'sjgk'"></MunicipalLevelData>
    </div>
    <div class="backHome" @click="handleBackHome">
      <el-button
        circle
        icon="el-icon-s-home"
      ></el-button>
    </div>
  </div>
</template>

<script>
import TaskControl from "../home/TaskControl.vue";
import ThreedSpaceControll from "../home/ThreedSpaceControll.vue"
import Index from "./components/Index.vue"
import MunicipalLevelData from "../home/MunicipalLevelData.vue"

export default {
  components: {
    TaskControl,
    ThreedSpaceControll,
    Index,
    MunicipalLevelData
  },
  name: "index",
  data() {
    return {
      uBtnPermissionList:[],
      ws: null,
      timeInfo: {
        currentTime: "10:04:06",
        date: "10-20",
        weekday: "星期一"
      },
      checkKey: 'gkzx',
      isEyeshield: false
    };
  },
  watch: {

  },
  mounted() {
    this.setTime();
    window.indexTimer = setInterval(this.setTime, 1000);
    this.initWS()
    this.getUserDetailInfo()
  },
  beforeDestroy() {
    if (window.indexTimer) {
      clearInterval(window.indexTimer)
    }
    if (this.ws) {
      this.ws.close()
    }
  },
  methods: {
    handleBackHome(){
        this.$router.push("/home")
    },
     getUserDetailInfo() {
      return this.getRequest("/user-server/api/u-user/getUserDetailInfo").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          let menuList = data.upermissionList;
          if (menuList && menuList.length > 0) {
            menuList.forEach(uPermission => {
              let menu = {
                id: uPermission.id,
                name: uPermission.name,
                type: uPermission.type,
                path: uPermission.path,
                children: uPermission.children
              };
            });
            sessionStorage.setItem("uPermissionList", JSON.stringify(menuList))
            this.uBtnPermissionList = this.getPageBtnRole("publicPermissions") || [];
          }

        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "confirmClass-style",
          //   iconClass: "",
          //   dangerouslyUseHTMLString: true,
          //   confirmButtonClass: "confirm",
          //   showCancelButton: false,
          // });
        }
      });
    },
    initWS() {
      let randomStr = JSON.parse(localStorage.getItem('userInfo')).userNo
      this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/login/${randomStr}`); //线上
      // this.ws = new WebSocket(`ws://192.168.205.102:8769/websocket/login/${randomStr}`); //内网102
      // this.ws = new WebSocket(`ws://192.168.205.105:8769/websocket/login/${randomStr}`); //内网105
      // this.ws = new WebSocket(`ws://220.248.31.146:9600/websocket/login/${randomStr}`); //线上上海测试
      // this.ws = new WebSocket(`ws://220.248.31.148:9600/websocket/login/${randomStr}`); //线上上海正式
      this.ws.addEventListener('open', () => {
        console.log('wsBigScreen连接成功');
      });
      this.ws.addEventListener("close", () => {
        console.log("wsBigScreen连接关闭");
      });
      this.ws.addEventListener("error", err => {
        console.log("wsBigScreen连接错误", err);
      });


    },
    changeIndexTheme() {
      this.isEyeshield = !this.isEyeshield
    },
    changeCheck(key) {
      if (key === this.checkKey) {
        return
      } else {
        this.checkKey = key
      }
    },
    setTime() {
      const d = new Date();
      const dStr = this.$moment(d).format("MM-DD HH:mm:ss");
      const dStrArr = dStr.split(" ");
      this.$data.timeInfo.currentTime = dStrArr[1];
      this.$data.timeInfo.date = dStrArr[0];
      const day = d.getDay();
      const weeks = ["星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"];
      this.$data.timeInfo.weekday = weeks[day];
    },
  },
}
</script>
<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#dashboardIndex {
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
}

.ordinaryModelHeader {
  pointer-events: none;
  z-index: 2003;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 16px;
  position: absolute;
  height: 78px;
  background-image: url("../../assets/img/dashboard/header.png");
}
.eyeshieldModelHeader {
  pointer-events: none;
  z-index: 2003;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 16px;
  position: absolute;
  height: 78px;
  background-image: url("../../assets/img/dashboard/header_eyes.png");
}
.headerLeft {
  position: absolute;
  left: 17px;
  z-index: 2005;
  display: flex;
}

.headerBtn {
  font-size: 22px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  background-size: 100% auto;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.headerBtn_eyes{
  font-size: 22px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  background-size: 100% auto;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}

.eyesBtn {
  position: absolute;
  cursor: pointer;
  z-index: 2005;
  top: 18px;
}

.eyeshieldModel {
  background: url("../../assets/img/home_eyes/hu_yan_click.png");
  width: 36px;
  height: 36px;
  background-size: 36px 36px;
  background-position: top;
  background-repeat: no-repeat;
}

.ordinaryModel {
  background: url("../../assets/img/home/hu_yan_click.png");
  width: 50px;
  height: 36px;
  background-size: 50px 36px;
  background-position: top;
  background-repeat: no-repeat;
}

.headerBtnIsAcitve {
  background-image: url("../../assets/img/dashboard/nav_click.png");
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  background-size: 100% auto;
  text-align: center;
  font-size: 22px;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.headerBtnIsAcitve_eyes{
  border-bottom: 3px solid #00aeff;
  font-size: 22px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  background-size: 100% auto;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}

.headerMiddle {
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16, 9, 0, 0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.headerRight {
  width: 370px;
  height: 78px;
  line-height: 78px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  display: flex;
}

@media screen and (max-width: 1920px) {
  .headerMiddle {
    font-size: 48px;
    line-height: 78px;
  }

  .headerRight {
    font-size: 27px;
  }

  .headerBtn,.headerBtn_eyes {
    width: 92px;
    height: 35px;
    font-size: 23px;
    line-height: 35px;
  }

  .headerBtnIsAcitve,.headerBtnIsAcitve_eyes{
    width: 92px;
    height: 35px;
    font-size: 23px;
    line-height: 35px;
  }

  .headerLeft {
    top: 23px;
  }

  .eyesBtn {
    right: 20px;
  }
}

@media screen and (min-width: 2000px) {
  .headerMiddle {
    line-height: 78px;
    font-size: 72px;
  }

  .headerRight {
    font-size: 40px;
    width: 535px;
  }

  .headerBtn,.headerBtn_eyes {
    width: 150px;
    height: 50px;
    font-size: 36px;
    line-height: 50px;
  }

 .headerBtnIsAcitve,.headerBtnIsAcitve_eyes {
    width: 150px;
    height: 50px;
    font-size: 36px;
    line-height: 50px;
  }

  .headerLeft {
    top: 16px;
  }

  .eyesBtn {
    right: 20px;
  }
}

.contentWrap {
  position: absolute;
  height: 100%;
  width: 100%;
}
.backHome {
  z-index: 1000;
  position: fixed;
  bottom: 5px;
  right: 12px;
  opacity: 0.35; /* 初始状态半透明 */
  transition: opacity 0.3s ease;
}
.backHome .el-button{
  border-radius: inherit;
}
.backHome:hover {
  opacity: 1;
}
.backHome >>> .el-button {
  font-size: 25px;
}
.backHome >>> .is-circle {
  padding: 8px;
}
.backHome >>> .el-button:hover {
  /* color: #1a7bb3; */
  color: #48361d;
}

/* >>> #overlay{
  height: 100% !important;
  top: 0 !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/dashboard/index.vue